/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'confluence.error.panel.refresh.app': 'Oppdater appen',
  'confluence.error.panel.reload.page': 'Oppdater siden',
  'confluence.icon.label': 'Ikon',
  'confluence.modal.dialog.close.modal.button': 'Avbryt',
  'confluence.select.required.field.message': 'Dette feltet er obligatorisk.',
  'confluence.text.area.required.field.message': 'Dette feltet er obligatorisk.',
  'confluence.textfield.validator.email': 'Angi en gyldig e-postadresse.',
  'confluence.textfield.validator.number': 'Angi et gyldig tall',
  'confluence.textfield.validator.required.field.message': 'Dette feltet er obligatorisk.',
  'confluence.textfield.validator.telephone': 'Oppgi et gyldig telefonnummer.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Tilgang kreves',
  'confluence.threeLOPrompt.modal.error.title': 'Feil',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Fant ikke nettadresse for samtykke. Oppdater siden og prøv igjen.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Fant ikke nettadresse for samtykke. Oppdater siden og prøv igjen.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Gi tilgang',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Konfigurer tilgang',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Kan ikke autentisere.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'For at {appString} skal vises, må du gi appen tilgang til Atlassian-produkter på dine vegne.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} krever ytterligere tilgang til kontoen din.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Advarsel om ekstern autentisering',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'denne appen',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Denne appen',
  'confluence.user.group.unknown.user.message': 'Ukjent bruker',
  'confluence.user.picker.empty.field.error.message': 'Dette feltet er obligatorisk.',
  'confluence.user.unknown.user.message': 'Ukjent bruker',
  'forge-ui.form.submit-button.text': 'Send inn',
};
